module.exports = __webpack_public_path__ + "static/media/golfer-5-a.d45180e1.png";